export const SPRITE_VERSION = "6eda5829";
